import { Component, Input, OnInit } from '@angular/core'
import { ObjectUtils } from '../../../../../shared/utils/object-utils'
import { triggerSmoothCollapseAnimation } from '../../../../../shared/animations/smooth-collapse.animation'
import { CmsFacetService } from '../../../../services/cms-search/cms-facet.service'
import { FAQResultItem } from '../../../types'

@Component({
  selector: 'mb-cms-search-result-item-faq',
  templateUrl: './cms-search-result-item-faq.component.html',
  styleUrls: ['./cms-search-result-item-faq.component.scss'],
  animations: [triggerSmoothCollapseAnimation]
})
export class CmsSearchResultItemFaqComponent implements OnInit {

  @Input() result: FAQResultItem | undefined
  title: string | undefined
  faqSnippet: string | undefined
  isCollapsed = true
  areFacetsVisible$ = this.facetService.areFacetsVisible$
  readonly domParser = new DOMParser()

  constructor (private facetService: CmsFacetService) {
  }

  ngOnInit (): void {
    this.title = ObjectUtils.getInnerText(this.result?.title ?? '')
    this.processFAQSnippet()
  }

  toggleCollapsed (): void {
    this.isCollapsed = !this.isCollapsed
  }

  private processFAQSnippet () {
    const snippet = this.domParser.parseFromString(this.result?.faqSnippet ?? '', 'text/html').body
    snippet.querySelectorAll('source').forEach(src => {
      src?.setAttribute('srcset', src?.getAttribute('lazyload') ?? src?.getAttribute('srcset') ?? '')
    })
    snippet.querySelectorAll('img').forEach(img => {
      img?.setAttribute('src', img?.getAttribute('ng-reflect-lazy-image') ?? img?.getAttribute('src') ?? '')
    })
    snippet.querySelectorAll('mb-open-panel-subcomponent-wrapper mb-panel-row-dot-plots-box span.img-action,' +
      ' mb-open-panel-subcomponent-wrapper mb-panel-row-image span.img-action,' +
      ' mb-open-panel-subcomponent-wrapper mb-panel-row-image-xl span.img-action')
      .forEach(imgAction => {
        imgAction?.remove()
      })
    this.faqSnippet = snippet.outerHTML
  }
}
